module.exports = __webpack_public_path__ + "921ee7e3ea98569bd7aa2d2e796b3e68.pdf";